import ScoreLineChart from './ScoreLineChart';
export default ScoreLineChart;



// WEBPACK FOOTER //
// ./src/components/ScoreLineChart/index.js